<button mat-icon-button (click)="toggleNotifications()" aria-label="Benachrichtigungen">
  @if (unreadCount$ | async; as count) {
    <mat-icon [matBadge]="count > 0 ? count : null" matBadgeColor="warn" matBadgeSize="small">
      notifications
    </mat-icon>
  } @else {
    <mat-icon>notifications</mat-icon>
  }
</button>
